module.exports = __webpack_public_path__ + "static/media/none.583a39db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/none.svg
// module id = 976
// module chunks = 0